import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, analytics } from 'utils/analytics';

/**
 * Hook to automatically track page views on route changes
 */
export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        trackPageView(location.pathname + location.search);
    }, [location]);
};

/**
 * Hook for tracking custom events
 * @returns {Object} Analytics object with event tracking methods
 */
export const useAnalytics = () => {
    return analytics;
};

